import React, { Component } from 'react';
import $ from 'jquery';
import ArrowIcon from '../../../assets/svg/catalog-right.svg?react';
import styles from './FJHorizontalVirtualizedList.module.less';
import PropTypes from 'prop-types';
class FJHorizontalVirtualizedList extends Component {
    _pageRefs = [];
    /**
     * @param props
     * @param {boolean} props.updateOnImageLoad - 视图里有图片加载成功后是否刷新组件
     * @param {{}} props.scrollerStyle - 滚动视图的样式
     * @param {number} props.moveDistance - 点击按钮进行滚动时，一次移动的距离，单位px
     * @param {function} props.leftClick - 点击向左滚动
     * @param {function} props.rightClick - 点击向右滚动
     * @param {function} props.gotoMinCallback - 滚动条到最左边的回调
     * @param {function} props.gotoMaxCallback - 滚动条到最右边的回调
     */
    constructor(props) {
        super(props);
        this.state = {
            left: 'show',
            right: 'show',
            moveDistance: props.moveDistance ? props.moveDistance : 420,

            loading: false,
            page: 0,
            showMsg: false,
            List: this._initList(props.list),
        };

        this.pageWidth = [];
    }

    componentDidMount() {
        $(this._scroller).on('scroll', () => {
            const scrollLeft = this._scroller.scrollLeft;
            const scrollWidth = this._scroller.scrollWidth;
            const offsetWidth = this._scroller.offsetWidth;

            if (scrollLeft <= 0) {
                if (this.props.gotoMinCallback) this.props.gotoMinCallback();
            }

            if (scrollLeft + offsetWidth >= scrollWidth) {
                if (this.props.gotoMaxCallback) this.props.gotoMaxCallback();
            }

            this._onScroll();
            this._updateArrow();
        });

        if (this.props.list && this.props.list.length > 0) {
            this._updateVisibleItems();
        }
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        if (
            nextProps.list &&
            (nextProps.list.length !== this.props.list.length ||
                JSON.stringify(nextProps.list) !== JSON.stringify(this.props.list))
        ) {
            let List = this._initList(nextProps.list);
            nextState.List = List;
        }

        return true;
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.list.length !== this.props.list.length && this.props.list) {
            this._updateVisibleItems();
        }
    }

    updateVisible = currentIndex => {
        const needLeft = this.state.moveDistance * (currentIndex === -1 ? 0 : currentIndex);
        this._scroller.scroll({ left: needLeft, behavior: 'smooth' });
    };

    _initList = list => {
        let newList = [];
        if (list) {
            list.forEach(item => {
                newList.push({
                    ...item,
                    visible: true,
                });
            });
        }
        return newList;
    };

    /**
     * @desc 更新可视区域的item，设置哪些item是可见的哪些不可见
     * @private
     */
    _updateVisibleItems = () => {
        window.requestAnimationFrame(() => {
            this.state.List.forEach((item, index) => {
                let itemRef = this._pageRefs[index];
                if (index === 0) {
                    this.pageWidth[index] = {
                        left: 0,
                        width: itemRef ? itemRef.offsetWidth : 0,
                    };
                } else {
                    let left = this.pageWidth[index - 1].left + this.pageWidth[index - 1].width;
                    this.pageWidth[index] = {
                        left: left,
                        width: itemRef ? itemRef.offsetWidth : 0,
                    };
                }
            });
            this._onScroll();
            this._updateArrow();
        });
    };

    /**
     * @description 返回适配后的滚动值
     * @param originLeft
     * @returns {FJHorizontalVirtualizedList._getScrollLeft.props|*|number}
     * @private
     */
    _getScrollLeft = originLeft => {
        // 显示区域最大width
        let srcollerBoxWidth = this._content.offsetWidth;
        // 滚动区域的宽度
        let srcollerWidth = this._scroller.scrollWidth;
        if (originLeft < 0) {
            return 0;
        }
        // TODO 将25改成0，改成之前的逻辑，避免组件的可用性不可用
        if (originLeft > srcollerWidth - srcollerBoxWidth - 0) {
            return srcollerWidth - srcollerBoxWidth;
        }
        let { viewSize = [] } = this.props;

        if (viewSize.length === 0) {
            return originLeft;
        }

        let needLeft = 0;
        for (let i = 0; i < viewSize.length; i++) {
            let nextLeft = needLeft + viewSize[i].width;
            if (nextLeft > originLeft) {
                needLeft = originLeft - (viewSize[i].width - (nextLeft - originLeft));
                break;
            }
            needLeft = needLeft + viewSize[i].width;
        }
        return needLeft;
    };

    _onScroll = () => {
        if (!this._scroller) {
            return;
        }

        // 显示区域最大Width
        let offsetWidth = this._scroller.offsetWidth;
        // 滚动条距离左边的距离
        let scrollLeft = Math.abs(this._scroller.scrollLeft);

        // 判断一下需要展示的列表，其他的列表都给隐藏了
        let ListShow = [...this.state.List];

        ListShow.forEach((item, index) => {
            if (this.pageWidth[index]) {
                let right = this.pageWidth[index].left + this.pageWidth[index].width;
                if (right < scrollLeft - 50 || this.pageWidth[index].left > scrollLeft + offsetWidth + 50) {
                    ListShow[index].visible = false;
                } else {
                    ListShow[index].visible = true;
                }
            }
        });
        this.setState({
            List: ListShow,
        });
    };

    _updateArrow = () => {
        if (!this._content || !this._scroller) {
            return;
        }

        // 显示区域最大width
        let scrollerBoxWidth = this._content.offsetWidth;
        // 滚动区域的宽度
        let scrollerWidth = this._scroller.scrollWidth;
        // 滚动条距离左边的距离
        let left = Math.abs(this._scroller.scrollLeft);

        if (scrollerWidth <= scrollerBoxWidth) {
            this.hideAll();
            return;
        }

        if (left === 0) {
            this.hideLeft();
        } else {
            this.showLeft();
        }

        // TODO 将25改成0，改成之前的逻辑，避免组件的可用性不可用
        if (left + scrollerBoxWidth + 10 >= scrollerWidth) {
            this.hideRight();
        } else {
            this.showRight();
        }
    };

    showAll = () => {
        this.setState({ left: 'show', right: 'show' });
    };
    hideAll = () => {
        this.setState({ left: 'hide', right: 'hide' });
    };
    hideLeft = () => {
        this.setState({ left: 'hide' });
    };
    showLeft = () => {
        this.setState({ left: 'show' });
    };
    hideRight = () => {
        this.setState({ right: 'hide' });
    };
    showRight = () => {
        this.setState({ right: 'show' });
    };
    leftClick = () => {
        if (!this._scroller) {
            return;
        }

        // 滚动条距离左边的距离
        let left = Math.abs(this._scroller.scrollLeft);
        let needLeft = this._getScrollLeft(left - this.state.moveDistance);
        this._scroller.scroll({ left: needLeft, behavior: 'smooth' });

        if (this.props.leftClick) this.props.leftClick();
    };
    rightClick = () => {
        if (!this._scroller) {
            return;
        }

        let left = Math.abs(this._scroller.scrollLeft);
        let needLeft = this._getScrollLeft(left + this.state.moveDistance);
        this._scroller.scroll({ left: needLeft, behavior: 'smooth' });

        if (this.props.rightClick) this.props.rightClick();
    };

    render() {
        let {
            scrollerStyle = {},
            containerStyle = {},
            arrowStyle = {},
            keyType = 'index',
            innerClassName,
            renderItem,
        } = this.props;

        const { List } = this.state;
        let leftWidth = 0;
        let rightWidth = 0;
        let i = 0;

        for (; i < List.length; i++) {
            if (!(List[i] && List[i].visible)) {
                leftWidth += this.pageWidth[i].width;
            } else {
                break;
            }
        }
        for (; i < List.length; i++) {
            if (!List[i].visible) {
                rightWidth += this.pageWidth[i].width;
            }
        }

        const renderList = List.map((item, index) => {
            if (item.visible || typeof item.visible === 'undefined') {
                let key = item.id || item.key || item.imageUrl || item.name || index;
                if (keyType === 'index') {
                    key = index;
                }
                return (
                    <div ref={ele => (this._pageRefs[index] = ele)} key={`page${key}`}>
                        {renderItem(item, item.visible, index)}
                    </div>
                );
            }
        });

        return (
            <div ref={ele => (this._content = ele)} className={styles.content} style={containerStyle}>
                <div
                    ref={ele => (this._scroller = ele)}
                    className={styles.item_box + ' u-no-scrollerbar'}
                    style={scrollerStyle}
                >
                    <div className={innerClassName}>
                        {Number(leftWidth) !== 0 && <div style={{ width: leftWidth }} />}
                        {renderList}
                        <div style={{ width: rightWidth }} />
                        {this.props.children}
                    </div>
                </div>
                {this.state.left === 'show' && !this.props.hideMoreButton ? (
                    <LeftArrow onClick={this.leftClick} style={arrowStyle} />
                ) : null}
                {this.state.right === 'show' && !this.props.hideMoreButton ? (
                    <RightArrow onClick={this.rightClick} style={arrowStyle} />
                ) : null}
            </div>
        );
    }
}

export default FJHorizontalVirtualizedList;

class LeftArrow extends Component {
    render() {
        let cn = styles.arrow_button + ' ' + styles.left;
        return (
            <div className={cn} style={this.props.style} onClick={this.props.onClick}>
                <ArrowIcon />
            </div>
        );
    }
}

class RightArrow extends Component {
    render() {
        let cn = styles.arrow_button + ' ' + styles.right;
        return (
            <div className={cn} style={this.props.style} onClick={this.props.onClick}>
                <ArrowIcon />
            </div>
        );
    }
}

LeftArrow.propTypes = {
    style: PropTypes.object,
    onClick: PropTypes.func,
};
RightArrow.propTypes = {
    style: PropTypes.object,
    onClick: PropTypes.func,
};
FJHorizontalVirtualizedList.propTypes = {
    updateOnImageLoad: PropTypes.bool,
    scrollerStyle: PropTypes.object,
    moveDistance: PropTypes.number,
    leftClick: PropTypes.func,
    rightClick: PropTypes.func,
    gotoMinCallback: PropTypes.func,
    gotoMaxCallback: PropTypes.func,
    list: PropTypes.array,
    keyType: PropTypes.string,
    innerClassName: PropTypes.string,
    renderItem: PropTypes.func,
    children: PropTypes.node,
    hideMoreButton: PropTypes.bool,
    containerStyle: PropTypes.object,
    arrowStyle: PropTypes.object,
    viewSize: PropTypes.array,
};
